const data = [
  
  {
    Name: "Parag Patkulkar",
    Board: "Main",
    Position: "President",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624851/sait%20images/Parag_Patkulkar_tynhxe.jpg",
    LinkedInProfile: "https://linkedin.com/in/parag-patkulkar-ba00891a8",
    GitHubProfile: "https://github.com/Quanta3",
    InstagramProfile:
        "https://www.instagram.com/_para.g403/",
  },

  {
    Name: "Prapti Gawande ",
    Board: "Main",
    Position: "Vice President",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624854/sait%20images/Prapti_Gawande_saci3u.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/prapti-gawande-54003b25a",
    GitHubProfile: "https://github.com/praptigawande2812",
    InstagramProfile: 
        "https://www.instagram.com/praptigawande_28?igsh=cnJ6azZoZ29zZmli",
  },

  {
    Name: "Prathamesh Patil",
    Board: "Main",
    Position: "Secretary",
    Photo:
      "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726412377/PrathameshPatilNew_wqm0n1.jpg",
    LinkedInProfile:"https://www.linkedin.com/in/prathamesh-patil-20b8aa28b",
    GitHubProfile: "https://github.com/94prathampatil",
    InstagramProfile: 
        "https://www.instagram.com/07_pratham_patil",
  },

  {
    Name: "Vedant Lonkar",
    Board: "Main",
    Position: "Secretary ",
    Photo:
      "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726411090/VedantLonkar_z6a4sq.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vedant-lonkar-4a37a91b8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/vedantlonkar23",
    InstagramProfile:
      "https://www.instagram.com/mevedantlonkar?igsh=ZTdwZ29jOTRnZ3N6",
  },

  {
    Name: "Atharva Khot",
    Board: "Main",
    Position: "Program Director",
    Photo:
      "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726410173/Atharva_-_Kavita_Khot_b8akqj.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/atharva-khot-3b2479257?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/atharvakhot78",
    InstagramProfile: 
        "https://www.instagram.com/_atharva017?igsh=MWJoMmZzMWQwMGoyYQ==",
  },

  {
    Name: "Mahemud Borgave",
    Board: "Main",
    Position: "Program Director ",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704356686/md_1_-_23620005_BORGAVE_MAHEMUD_USMAN_nnhxht.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/mahemud-borgave-b01762231",
    GitHubProfile: "https://github.com/mahemudborgave",
    InstagramProfile:
      "https://www.instagram.com/95_mahemud",
  },

  {
    Name: "Vaibhav Kondekar",
    Board: "Main",
    Position: "Program Director ",
    Photo:
      "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726410773/VaibhavKondekar_dsiczi.webp",
    LinkedInProfile: "https://www.linkedin.com/in/vaibhav-kondekar-671234265?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/vaibhavKondekar",
    InstagramProfile:
      "https://www.instagram.com/_vaibhav_7897?igsh=MWdiZnJzeHpudXlvbg==",
  },

  {
    Name: "Purva Patil",
    Board: "Main",
    Position: "Club Service Director",
    Photo:
      "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726411387/PurvaPatil_caaecv.png",
    LinkedInProfile: "https://www.linkedin.com/in/purva-patil-a29175270/?trk=public-profile-join-page",
    GitHubProfile: "https://github.com/piya200",
    InstagramProfile: "https://www.instagram.com/purva_patil_2108?igsh=MXIzdzh1ZzVjZzVkbw==",
  },

  {
    Name: "Aditya Aparadh",
    Board: "Main",
    Position: "Club Service Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624824/sait%20images/Aditya_Aparadh_o603b1.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/aditya-aparadh/",
    GitHubProfile: "https://github.com/AdityaAparadh",
    InstagramProfile: "-",
  },

  {
    Name: "Sandesh Shinde",
    Board: "Main",
    Position: "Club Service Director",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704356554/20231231_175933_-_Sandesh_Shinde_bhcg8x.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/sandesh-shinde-s1730?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/sandeshshinde30",
    InstagramProfile: "https://www.instagram.com/sandesh_shinde_1730/",
  },

  {
    Name: "Tanmay Shingde",
    Board: "Main",
    Position: "Web Developer",
    Photo:
      "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726410612/TanmayShingde_qnltb7.png",
    LinkedInProfile: "https://www.linkedin.com/in/tanmayshingde?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/tanmay-8",
    InstagramProfile: "-",
  },

  {
    Name: "Hemant Sharma",
    Board: "Main",
    Position: "Web Developer",
    Photo:
      "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726409593/HemantSharma_rlybrr.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/hemant-sharma-690587256/",
    GitHubProfile: "https://github.com/hemantsharma2004",
    InstagramProfile: "-",
  },

  {
    Name: "Satej Sawant",
    Board: "Main",
    Position: "Programming Expert",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624861/sait%20images/Satej_Sawant_p4jvnv.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/satej-sawant-92a8a4269/",
    GitHubProfile: "https://github.com/SatejSawant45",
    InstagramProfile:
      "https://www.instagram.com/satej.s?igsh=ZWVrc2Rua29td2p2",
  },

  {
    Name: "Aditya Khandare",
    Board: "Main",
    Position: "Programming Expert",
    Photo:
      "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726408725/AdityaKhandare_kcv2m9.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/aditya-khandare-4a3b91252/",
    GitHubProfile: "https://github.com/Aditya-8320",
    InstagramProfile:
      "https://www.instagram.com/adityakhandare8320/",
  },

  {
    Name: "Vidyadhar Dinde",
    Board: "Main",
    Position: "Programming Expert and Art designer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624879/sait%20images/Vidyadhar_dhinde_maqujm.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vidyadhar-dinde-447371252/",
    GitHubProfile: "https://github.com/vidyadhardinde001",
    InstagramProfile:
      "https://www.instagram.com/_vidyadhar_d/",
  },

  {
    Name: "Divya Tarkase",
    Board: "Main",
    Position: "Public Relation Officer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624845/sait%20images/Divya_Tarkase_zesjnq.jpg",
    LinkedInProfile:
      "https://www.linkedin.com/in/divya-tarkase-56ab30265?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/DivyaTarkase",
    InstagramProfile: "-",
  },

  {
    Name: "Shreyas Kamble",
    Board: "Main",
    Position: "Public Relation Officer",
    Photo:
      "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726410424/ShreyasKamble_ccumsp.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/shreyas-kamble-aa465922a",
    GitHubProfile: "https://github.com/shreyaskamble1612",
    InstagramProfile:
      "https://www.instagram.com/shreyas__1612?igsh=ejhnZnd1cjBndXg3",
  },

  {
    Name: "Shreyash Pawar",
    Board: "Main",
    Position: "Public Relation Officer and Treasurer",
    Photo:
        "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726411837/ShreyashPawar_umkfyc.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/shreyash-pawar-386486249",
    GitHubProfile: "https://github.com/Ssp63",
    InstagramProfile: "https://www.instagram.com/s.s.p_63/?hl=en",
  },

  {
    Name: "Anuja Suntnur",
    Board: "Main",
    Position: "Aptitude Developer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624844/sait%20images/Anuja_Suntnur_gdbyof.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/anuja-suntnur-93176225b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/anuja2004",
    InstagramProfile:
      "https://www.instagram.com/_anuja_suntnur/",
  },
  
  {
    Name: "Vedant Panari",
    Board: "Main",
    Position: "Aptitude Developer ",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624878/sait%20images/Vedant_Panari_h6huyi.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vedant-panari-379869287?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/Vedant-Panari",
    InstagramProfile:
      "https://www.instagram.com/vedantpanari?igsh=MW5qbGl5YWp1OHhoZQ==",
  },

  {
    Name: "Tamnna Malgave",
    Board: "Main",
    Position: "Art designer",
    Photo:
      "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726408959/TamannaMalgave_lcewex.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/tamnna-malgave-a23461299",
    GitHubProfile: "https://github.com/TamnnaMalgave",
    InstagramProfile: "-",
  },


  {
    Name: "Aryan Babar",
    Board: "Main",
    Position: "Art designer and Editor ",
    Photo:
      "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726409894/AryanBabar_awvjig.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/aryan-babar-84771a259",
    GitHubProfile: "https://github.com/Aaryalegend",
    InstagramProfile: "https://www.instagram.com/aryanbabar5796",
  },
  {
    Name: "Gaurav Gokhale",
    Board: "Main",
    Position: "Resource Manager",
    Photo:
      "https://res.cloudinary.com/dk9fzvliu/image/upload/v1726409111/GauravGokhale_nwtdin.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/gauravgokhale07/",
    GitHubProfile: "https://github.com/Grg07",
    InstagramProfile: "-",
  },
];
export default data;
